module.exports = __webpack_public_path__ + "img/s-l1600.8ba2baf9.jpg";